import * as types from './mutation-types.js';
import {cookie} from '../utils/cookie.js';
import urlsearch from '../utils/urlSearch.js';

export const mutations = {
	//同步当前part
	[types.CHANGE_CURRENTPART](state, changeCurrent) {
		state.currentPart = changeCurrent.currentPart;
	},
	//分批次请求每个模块数据
	[types.GET_PART_DATA](state, data) {
		state.partsArr[data.index] = data.responseData;
		state.everyPart = state.partsArr[data.index];
	},
	//点击查看更多
	[types.LOAD_MORE](state, moreData) {
		state.partsArr[moreData.index].items = state.partsArr[moreData.index].items.concat(moreData.responseData);
		state.everyPart = state.partsArr[moreData.index];
		state.currentPart = moreData.index;
	},
	//右侧气泡的展示隐藏
	[types.IS_SHOW_POP](state, currentState) {
		state.isShowPop = currentState.state;
	},
	//更改顶部slider是否展示全部选项
	[types.IS_SHOW_ALL_PART](state, isShowAllPart) {
		state.isShowAllPart = isShowAllPart.state;
	},
	//已经申请建立数量
	[types.GET_APPLY_NUM](state, hasApplyNum) {
		if (hasApplyNum.responseData.message === 'success' && hasApplyNum.responseData.num < 5) {
			state.isShowPop = true;
			state.hasApplyNum = hasApplyNum.responseData.num;
			window.clickLog && window.clickLog('from=m_aggregation_todeliveryshown');
		}
	},
	//初始化城市、用户id、页面来源等信息
	[types.INITINFO](state) {
		state.mcity = cookie.getCookie('mcity') || '';
		state.userid = cookie.getCookie('PPU').split('&')[0].split('=')[1] || '';
		state.source = urlsearch.query('source') || '';
		state.dispcateid = urlsearch.query('dispcateid') || '';
	},
	//记录滚动条高度(点击展开后立即点击收起情况下用)
	[types.CURRENTSCROLLTOP](state, currentScrollTop) {
		state.currentScrollTop = currentScrollTop.currentScrollTop;
	}
};
export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js